import React from 'react';
import UserForm from '../components/UserForm';
import UserList from '../components/UserList';
import useUsers from '../hooks/useUsers';
import fetchWithAuth from '../utils/fetchWithAuth';

const UsersPage = ({ user }) => {
  // If no role, render nothing
  if (!user?.role) return null;

  const {
    users,
    addUser,
    editUser,
    removeUser,
    editingUser,
    setEditingUser,
    genericSavedMsg
  } = useUsers(user);

  const isConductor = user.role === "Conductor" || user.role === "conductor";

  return (
    <div className="space-y-6">
      {genericSavedMsg && (
        <div className="bg-green-100 text-green-800 px-4 py-2 rounded">
          {genericSavedMsg}
        </div>
      )}
      {/* Only show the form if NOT conductor */}
      {!isConductor && (
        <UserForm
          onSave={editingUser ? editUser : addUser}
          editingUser={editingUser}
          onCancelEdit={() => setEditingUser(null)}
          currentUser={user}
        />
      )}
      <UserList
        users={users}
        onEdit={isConductor ? undefined : setEditingUser}
        onRemove={isConductor ? undefined : removeUser}
        isConductor={isConductor}
      />
    </div>
  );
};

export default UsersPage;